export default "__VITE_ASSET__CYS8bca3__"